var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Loading from '@doordash/component-loading';
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import * as queryString from 'query-string';
import { getIdentityUrl } from '../../../utils/identity_helper';
import LocationPathHelper from '../../../utils/location_path_helper';
import { TeamMemberRole } from '../../../types/GloblalTypes';
import { HOME_PAGE_PATH, EXTERNAL_ROUTES } from '../../../constants/values';
import { useTeamData } from '../../AppStructure/hooks/useTeamData';
import { useGetConsumerInfo } from '../../DynamicValues/hook';
import { testIds as SignupTeamTestId } from './testIds';
import { getUserTeamRoles } from './utils';
import CreateTeam from './CreateTeam';
/**
 * Used in the Self Serve Expensed Meals flow, this component encapsulate the logic
 * to determin if a user should create a Team (and Team Account)
 * Given that the user can be one of the many states, we determine the user state on mount
 * and then the render path
 *| user state                    | Render Component | hard redirect    | soft redirect | Determination logic                |
 *|-------------------------------|------------------|------------------|---------------|------------------------------------|
 *| Logged out user               | Loading Spinner  | Yes (IDS signup) | NA            | useGetConsumerInfo                 |
 *| Logged in user - admin        | Loading Spinner  | NA               | /teams/home   | useTeamData + list operation logic |
 *| Logged in user - member       | Loading Spinner  | Yes (/benefits)  | NA            | useTeamData + list operation logic |
 *| Logged in user - No team data | TBD              | NA               | NA            | useTeamData + list operation logic |
 *
 */
var SignupTeam = function () {
    var _a = useGetConsumerInfo(), isGuest = _a.isGuest, consumerInfoLoading = _a.loading, error = _a.error;
    var _b = useTeamData({
        skip: isGuest || consumerInfoLoading,
    }), teamData = _b.data, teamDataLoading = _b.loading;
    var _c = __read(React.useState(false), 2), hasNoPortalData = _c[0], setHasNoPortalData = _c[1];
    var _d = __read(React.useState(null), 2), role = _d[0], setRole = _d[1];
    // Case 1 - Handle a user being on this page
    React.useEffect(function () {
        if ((!consumerInfoLoading && isGuest) || error) {
            var currentSearch = LocationPathHelper.getWindowLocationSearch();
            var _a = queryString.parse(currentSearch), email = _a.email, phone = _a.phone, firstName = _a.firstName, lastName = _a.lastName;
            var nextPath = "" + (LocationPathHelper.getPathName() || HOME_PAGE_PATH) + currentSearch;
            window.location.href = getIdentityUrl({ nextPath: nextPath }, {
                identityMode: 'signup',
            }, { email: email, phone: phone, firstName: firstName, lastName: lastName });
        }
    }, [isGuest, consumerInfoLoading, error]);
    React.useEffect(function () {
        if (teamDataLoading || !teamData) {
            return;
        }
        if (!teamData.teamData) {
            // Case 4 - user have no team data, set a flag for render path
            setHasNoPortalData(true);
            return;
        }
        // user should be either Member or Admin at this code path
        // list logic for Case 2 and Case 3
        var _a = getUserTeamRoles(teamData), isAdmin = _a.isAdmin, isMember = _a.isMember;
        // set the flag for render path
        var finalRole = null;
        if (isAdmin) {
            finalRole = TeamMemberRole.ADMIN;
        }
        else if (isMember) {
            finalRole = TeamMemberRole.MEMBER;
        }
        setRole(finalRole);
    }, [teamData, teamDataLoading]);
    React.useEffect(function () {
        // Case 3 - Hard redirect to /benefits page as member
        if (role === TeamMemberRole.MEMBER) {
            window.location.href = EXTERNAL_ROUTES.BENEFITS_PAGE;
        }
    }, [role]);
    if (consumerInfoLoading || teamDataLoading) {
        return (React.createElement("div", { "data-testid": SignupTeamTestId.loadingSpinner },
            React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
    }
    if (role === TeamMemberRole.ADMIN) {
        // Case 2 - use React router to redirect to homepage of Work Portal
        return React.createElement(Redirect, { to: HOME_PAGE_PATH });
    }
    if (role === TeamMemberRole.MEMBER) {
        // Case 3 - we need to do a hard redirect, so a loading spinner here while useEffect take care of redirect
        return (React.createElement("div", { "data-testid": SignupTeamTestId.loadingSpinner },
            React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
    }
    if (hasNoPortalData) {
        return React.createElement(CreateTeam, null);
    }
    return (React.createElement("div", { "data-testid": SignupTeamTestId.loadingSpinner },
        React.createElement(Loading, { size: Loading.Sizes.Medium, color: Loading.Colors.SystemGrey30 })));
};
export default SignupTeam;
